/**
 * Feature setting for enabling the AI chatbot in the Help Center for native mobile
 */
export const HELP_CENTER_AI_CHATBOT_NATIVE_MOBILE_240909 = 'HELP_CENTER_AI_CHATBOT_NATIVE_MOBILE_240909';
